var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #662d89;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.01,
    y: 0.01,
    width: 99.97,
    height: 99.97,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.23,27.59l12.03,17.65,15.24-17.65h4.25l-17.53,20.43,19.13,27.89h-14.25c-4.16-6.3-8.51-12.47-12.79-18.68l-16.04,18.68h-4.29l18.4-21.47-18.4-26.85h14.25ZM68.5,72.89l-29.4-42.09h-6.28l29.4,42.09h6.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterTheme);
export default __webpack_public_path__ + "static/media/twitter_theme.e725875126f43be5021bc5cd6f9c0a3e.svg";
export { ForwardRef as ReactComponent };